<footer class="footer">
    <div class="footer-content justify-content-center">
        <p class="m-b-0">Copyright © 2022 Kapylearn. Powered by Kapyedu.com</p>
    </div>
</footer>
